import api from '@/apis/di/budgetKindItemAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('budgetKindItem', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_budget_kind_item',
    field: {
      key: 'budget_kind_item_id',
      code: 'budget_kind_item_code',
      name: 'budget_kind_item_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
